import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { OrgProducts } from "../../../components/organization-tabs/org-products/org-products";
import { OrgUsers } from "../../../components/organization-tabs/org-users/org-users";
import { OrgDetails } from "./org-details";
import { Breadcrumb } from "../../../components/breadcum";
import { OnlineConnections } from "./customers-list/online-connections/list";
import { OfflineConnections } from "./customers-list/offline-connections/list";
import { RetailerInvoices } from "../retailerInvoices/list";
import { TransactionInvoices } from "../transactionInvoices/list";
import { OrdersList } from "./ondc-orders/orders/list";
import { BuDetails } from "./roles-privilege/list";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import { Card } from "react-bootstrap";
import { FormatIndianDate } from "../../../app/utility/formatIndianDate";
import { SubscriptionData } from "./subscriptions/list";
import { Tickets } from "../tickets/list";

export const OrgTabInfo = () => {
  const navigate = useNavigate();
  const params = useParams();

  const tabs = [
    { id: "1", title: "Details", route: "details", content: <BuDetails /> },
    { id: "2", title: "Subscriptions", route: "subscription", content: <SubscriptionData /> },
    { id: "3", title: "Menu System", route: "menu-system", content: <OrgDetails /> },
    { id: "4", title: "Products", route: "products", content: <OrgProducts /> },
    { id: "5", title: "Users", route: "users", content: <OrgUsers /> },
    { id: "6", title: "Online Connections", route: "online-connections", content: <OnlineConnections /> },
    { id: "7", title: "Offline Connections", route: "offline-connections", content: <OfflineConnections /> },
    { id: "8", title: "ONDC Orders", route: "ondc-orders", content: <OrdersList /> },
    { id: "9", title: "Retail Invoice", route: "retailer", content: <RetailerInvoices /> },
    { id: "10", title: "Transaction Invoice", route: "transaction", content: <TransactionInvoices /> },
    { id: "11", title: "Tickets", route: "ticket", content: <Tickets /> },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [loading, setLoading] = useState<boolean>(false);
  const [breadcrumbInfo, setBreadcrumbInfo] = useState<any>([])
  const [buData, setBuData] = useState<any>();

  useEffect(() => {
    const currentTab = tabs.find((tab) => tab.route === params?.tabRoute);
    if (currentTab) {
      setActiveTab(currentTab.id);
    }
  }, [params?.tabRoute]);

  useEffect(() => {
    if (!params?.tabRoute) {
      navigate(`/dashboard/organizations/org-details/${params?.org}/${tabs[0].route}`);
    }
  }, [params, navigate]);

  useEffect(() => {
    getUserRoleData();
  }, [])

  const handleTabClick = (tabId: string) => {
    const selectedTab = tabs.find((tab) => tab.id === tabId);
    if (selectedTab) {
      setActiveTab(tabId);
      navigate(`/dashboard/organizations/org-details/${params?.org}/${selectedTab.route}`);
    }
  };

  const getUserRoleData = async () => {
    let payload = { id: params.org };
    setLoading(true);
    try {
      let encrytedData = encrypt(JSON.stringify(payload));
      const res = await ApisService.getOrganizationData("findById", encrytedData);
      const userData = JSON.parse(dataDecrypt(res.data.data));
      setBuData(userData[0]);
      const data = [
        {
          label: "Business Units",
          value: "Business Units",
          routerLink: `/dashboard/organizations`,
          isActive: false,
        },
        {
          label: userData[0]?.business_name,
          value: userData[0]?.business_name,
          routerLink: ``,
          isActive: true,
        }
      ];
      setBreadcrumbInfo(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }


  return (
    <div className="container-fluid content-bg-color">
      {!loading && <>
        <div>
          <Breadcrumb breadCrumbList={breadcrumbInfo} />
        </div>
        <Card className="mb-2">
          <Card.Body className="py-2">
            <div className="row">
              <div className="col-md-3 lh-1-5 my-1">
                <div className="fw-bold">Bu Name</div>
                <div>{buData?.business_name}</div>
              </div>
              <div className="col-md-3 lh-1-5 my-1">
                <div className="fw-bold">Head of business</div>
                <div>{buData?.head_of_business}</div>
              </div>
              <div className="col-md-3 lh-1-5 my-1">
                <div className="fw-bold">Contact number</div>
                <div>{buData?.contact_number}</div>
              </div>
              <div className="col-md-3 lh-1-5 my-1">
                <div className="fw-bold">Register Date</div>
                <div>{FormatIndianDate(buData?.created_date, "dateWithTime")}</div>
              </div>
            </div>
          </Card.Body>
        </Card>
        <div className="overflow-auto no-vertical-scroll scroll-container">
          <ul
            className="nav nav-tabs flex-nowrap"
            id="myTab"
            role="tablist"
            style={{ minWidth: 'max-content', whiteSpace: 'nowrap' }}
          >
            {tabs.map((tab) => (
              <li className="nav-item" role="presentation" key={tab.id}>
                <button
                  className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                  id={`${tab.id}-tab`}
                  onClick={() => handleTabClick(tab.id)}
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  aria-controls={tab.id}
                  aria-selected={activeTab === tab.id}
                >
                  {tab.title}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="tab-content" id="myTabContent">
          {tabs.map((tab) => (
            <div
              className={`tab-pane fade ${activeTab === tab.id ? "show active" : ""}`}
              id={tab.id}
              role="tabpanel"
              aria-labelledby={`${tab.id}-tab`}
              key={tab.id}
            >
              {activeTab === tab.id && tab.content}
            </div>
          ))}
        </div>
      </>}
    </div>
  );
};
